// Formates a number to a string with a space for every thousand. EG: 10000 = 10 000

function thousandSeparator(number: string) {
    if (number.toString() === "0") return "-"

    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, String.fromCharCode(160))
}

export default thousandSeparator
